import { configureStore } from '@reduxjs/toolkit'
import CartReducer from 'reducers/Cart'
import SideMenuReducer from 'reducers/SideMenu'

export default configureStore({
  reducer: {
    cart: CartReducer,
    sideMenu: SideMenuReducer
  },
})